var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRefresh24({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 6.3L19.9 9.3L17 8.2M3 16.8L4.1 13.8L7 14.9M19.4 14.8C18.2 17.9 15.3 20 12 20C8.7 20 5.9 17.9 4.6 14.9M4.6 8.1C5.8 5.1 8.7 3 12 3C15.3 3 18.2 5.1 19.4 8.1",
    stroke: "#111827",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh24);
export default __webpack_public_path__ + "static/media/icon-refresh-24.8820db62bed27104745fd143fa9520b0.svg";
export { ForwardRef as ReactComponent };